import React from "react";
import {
    Table, Input, Space,
    Drawer, Switch, Tooltip, Modal
} from 'antd';
import Button from "antd-button-color";
import Highlighter from 'react-highlight-words';
import { SearchOutlined, PlusOutlined, ToolOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { getStoreList, storeStatus } from "./service";
import Addform from "./addform"
import Editform from "./editform"
import reqwest from 'reqwest';
import * as config from "../../config";
import UserProfile from '../../UserProfile';
import get from "lodash";
import isequal from "lodash";
import _ from "lodash";
const { confirm } = Modal;
function success(e) {
    // console.log('www', e)
    let secondsToGo = 15;
    const onOkModal = () => {
        // window.location.reload();
    }
    const modal = Modal.success({
        title: 'จัดการข้อมูลร้านค้า เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        // window.location.reload();
    }, secondsToGo * 1000);
}

function showConfirm(e) {
    // console.log('e', e)
    if (e.e == true) {
        // console.log('เปิด');
        confirm({
            title: 'ต้องการเปิดการใช้งานร้านค้านี้ ใช่หรือไม่?',
            icon: <ExclamationCircleOutlined />,
            content: e.record.store_name,
            okText: 'ใช่',
            // okType: 'danger',
            cancelText: 'ไม่ใช่',
            onOk() {
                // console.log('OK');
                let data = {
                    "status": 'active',
                    "storeCd": e.record.storeCd
                }
                storeStatus(data).then(res => {
                    // console.log("res===", res)
                    if (res && res.status === 200) {
                        success('no')
                    }
                })
            },
            onCancel() {
                // console.log('Cancel');
            },
        });
    } else {
        // console.log('ปิด');
        confirm({
            title: 'ต้องการปิดการใช้งานร้านค้านี้ ใช่หรือไม่?',
            icon: <ExclamationCircleOutlined />,
            content: e.record.store_name,
            okText: 'ใช่',
            // okType: 'danger',
            cancelText: 'ไม่ใช่',
            onOk() {
                // console.log('OK');
                let data = {
                    "status": 'not active',
                    "storeCd": e.record.storeCd
                }
                storeStatus(data).then(res => {
                    // console.log("res===", res)
                    if (res && res.status === 200) {
                        success('off')
                        // form.resetFields();
                    }
                })
            },
            onCancel() {
                // console.log('Cancel');
            },
        });
    }
}

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: true,
        render: name => `${name.first} ${name.last}`,
        width: '20%',
    },
    {
        title: 'Gender',
        dataIndex: 'gender',
        filters: [
            { text: 'Male', value: 'male' },
            { text: 'Female', value: 'female' },
        ],
        width: '20%',
    },
    {
        title: 'Email',
        dataIndex: 'email',
    },
];

const getRandomuserParams = params => ({
    results: params.pagination.pageSize,
    page: params.pagination.current,
    ...params,
});

class Shop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            sortedInfo: null,
            data: [],
            visible: false,
            visibleEdit: false,
            current: 1,
            pageSize: 10,
            storeDetail: null,

            data1: [],
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: false,
            filteredData: []
        };

    }
    componentDidMount(params = {}) {
        this.getData(params);

        const { pagination } = this.state;
        this.fetch({ pagination });

    }

    getData = (params) => {
        // console.log("paramsparams===", params)
        getStoreList().then(res => {
            // console.log("res===", res)
            if (res && res.status === 200) {
                // this.setState({
                //     data: res.data.info
                // })
                this.setState({
                    loading: false,
                    data: res.data.info,
                    pagination: {
                        current: 1,
                        pageSize: 10,
                        total: res.data.info.length,
                    },
                });
            }
        })
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (

            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            isequal(this.state.searchedColumn, dataIndex) ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    getColumnSearchProps2 = (dataIndex, lastName_th) => ({
        
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        // render: (text, record) =>
        //     isequal(this.state.searchedColumn, dataIndex) ? (
        //         <Highlighter
        //             highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        //             searchWords={[this.state.searchText]}
        //             autoEscape
        //             textToHighlight={text ? text.toString()+lastName_th : ''}
        //         /> 
        //     ) : (
        //         text
        //     ),
    });

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    };

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    };

    setAgeSort = () => {
        this.setState({
            sortedInfo: {
                order: 'descend',
                columnKey: 'age',
            },
        });
    };

    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    showDrawerEdit = (e) => {
        // console.log("showDrawerEdit", e.record)

        this.setState({
            visibleEdit: true,
            storeDetail: e.record
        });
    };

    onCloseEdit = () => {
        this.setState({
            visibleEdit: false,
        });
    };

    renderEditForm = (e) => {
        // console.log("render", e)
        return (
            <Drawer
                title="แก้ไขข้อมูลร้านค้า"
                width={720}
                onClose={this.onCloseEdit}
                visible={this.state.visibleEdit}
                bodyStyle={{ paddingBottom: 1 }}

            >
                <Editform
                    storeDetail={this.state.storeDetail}
                    userLevel={e}
                />
            </Drawer>
        )
    }
    onChangeSwitch = (checked) => {
        showConfirm(checked)
    }

    handleChange = (pagination, filters, sorter) => {
        // console.log('Various parameters', pagination, filters, sorter);
        window.location.reload();
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
            current: pagination.current,
            pageSize: pagination.pageSize
        });
    };

    handleSearch = (selectedKeys, confirm, dataIndex, currentDataSource, params = {}) => {
        // this.getData(params);
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleTableChange = (pagination, filters, sorter, currentDataSource, params = {}) => {
        this.fetch({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    fetch = (params = {}) => {
        var current = this.state.pagination.current
        var pageSize = this.state.pagination.pageSize
        var authorization = config.headerCallAPI
        var token = ''
        if (UserProfile.getUserdata()) {
            token = UserProfile.getUserdata().token
        }
        authorization.headers['Authorization'] = "Bearer " + token;
        this.setState({ loading: true });
        reqwest({
            // url: config.urlAPI + '/store/get?limit=' + params.pagination.pageSize + '&page=' + params.pagination.current,
            url: config.urlAPI + '/store/get?limit=' + params.pagination.pageSize + '&page=' + params.pagination.current,
            method: 'get',
            type: 'json',
            data: getRandomuserParams(params),
            headers: {
                authorization: "Bearer " + token,
                Accept: 'application/json',
            },
        }).then(data => {
            // console.log(data);
            this.setState({
                loading: false,
                data1: data.info.data,
                pagination: {
                    ...params.pagination,
                    total: data.info.total,
                },
            });
        });
    }

    dd = () => {
        console.log('dddd', this.state)
    }

    render() {
        // console.log('rendershope', this.props)
        let level = this.props.userdata.userdata.level

        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        var current = this.state.pagination.current
        var pageSize = this.state.pagination.pageSize
        const columns1 = [
            {
                title: 'ลำดับ',
                align: 'center',
                width: '4%',
                key: 'no',
                render: (text, record, index) => {
                    return (((current - 1) * pageSize) + index + 1)
                },
            },
            {
                title: 'รหัสเขต',
                dataIndex: 'saleAreaCd',
                key: 'saleAreaCd',
                width: '6%',
                ...this.getColumnSearchProps('saleAreaCd'),
            },
            {
                title: 'ชื่อเขต',
                dataIndex: 'saleAreaDesc',
                key: 'saleAreaDesc',
                width: '8%',
                ...this.getColumnSearchProps('saleAreaDesc'),
            },
            {
                title: 'รหัสร้านค้า',
                dataIndex: 'storeCd',
                key: 'storeCd',
                width: '7%',
                ...this.getColumnSearchProps('storeCd'),
            },
            {
                title: 'ชื่อร้านค้า',
                dataIndex: 'store_name',
                key: 'store_name',
                width: '16%',
                // sorter: (a, b) => a.name.length - b.name.length,
                // sortOrder: sortedInfo.columnKey === 'store_name' && sortedInfo.order,
                ellipsis: true,
                ...this.getColumnSearchProps('store_name'),
            },
            {
                title: 'ชื่อผู้รับผิดชอบ',
                key: 'firstName_th',
                dataIndex: ['firstName_th', 'lastName_th'],
                width: '12%',
                render: (text, record) => (
                    <Space size="small">
                        {record.firstName_th}{record.lastName_th}
                    </Space>
                ),
                ...this.getColumnSearchProps2('firstName_th'),
            },
            {
                title: 'แก้ไข',
                key: 'action',
                width: '4%',
                align: 'center',
                fixed: 'right',
                render: (text, record) => (
                    <Space size="small">
                        <Tooltip title="edit shop">
                            <Button with="ghost" type="success" shape="circle" icon={<ToolOutlined />} size="small"
                                // onClick={this.showDrawerEdit}
                                onClick={() => {
                                    this.showDrawerEdit({ record })
                                    // console.log("record", record)
                                }
                                }
                            />
                        </Tooltip>
                    </Space>
                ),
            },
            {
                title: 'สถานะ',
                key: 'status',
                width: '5%',
                align: 'center',
                fixed: 'right',
                render: (text, record) => (
                    <Tooltip title={record.isActive == 1 ? "active" : "not active"}>
                        <Switch
                            // disabled={level == 1 ? true : false}
                            defaultChecked={record.isActive == 1 ? true : false}
                            onChange={(e) => {
                                this.onChangeSwitch({ e, record })
                                // console.log("record", record)
                            }
                            }
                            checkedChildren="เปิด"
                            unCheckedChildren="ปิด"
                        />
                    </Tooltip>
                ),
                ellipsis: true,
            },
        ];

        let data11 = []
        const { data, data1, pagination, loading, searchText, searchedColumn } = this.state;
        // console.log("renderthis.state.searchText", data, data1, pagination, loading, searchText, searchedColumn)

        if (searchText === '') {
            data11 = data1
        } else if (searchedColumn === 'saleAreaCd') {
            if (data.length > 0) {
                let results = data.filter(o => o.saleAreaCd.includes(searchText));
                data11 = results
                pagination.total = results.length
            }
        } else if (searchedColumn === 'saleAreaDesc') {
            if (data.length > 0) {
                let results = data.filter(o => o.saleAreaDesc.includes(searchText));
                data11 = results
                pagination.total = results.length
            }
        } else if (searchedColumn === 'storeCd') {
            if (data.length > 0) {
                let results = data.filter(o => o.storeCd.includes(searchText));
                data11 = results
                pagination.total = results.length
            }
        } else if (searchedColumn === 'store_name') {
            if (data.length > 0) {
                let results = data.filter(o => o.store_name.includes(searchText));
                data11 = results
                pagination.total = results.length
            }
        } else if (searchedColumn === 'firstName_th') {
            if (data.length > 0) {
                let results = data.filter(o => o.firstName_th.includes(searchText));
                data11 = results
                pagination.total = results.length
            }
        }
        // console.log("renderdata11", data11)

        return (
            <>
                <Space style={{ marginBottom: 16 }}>
                    <h2 onClick={this.dd}>จัดการข้อมูลร้านค้า</h2>
                </Space>
                <Button type="primary" onClick={this.showDrawer} style={{ float: 'right' }}>
                    <PlusOutlined /> Add Shop
                </Button>
                <Table
                    columns={columns1}
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    rowKey={record => record.id}
                    dataSource={data11}
                    pagination={pagination}
                    loading={loading}
                    onChange={this.handleTableChange}
                    scroll={{ x: 1000 }}
                    size="small"
                    bordered
                />
                <Drawer
                    title="เพิ่มร้านค้า"
                    width={720}
                    onClose={this.onClose}
                    visible={this.state.visible}
                    bodyStyle={{ paddingBottom: 1 }}
                >
                    <Addform />
                </Drawer>
                { this.state.visibleEdit ? this.renderEditForm(level) : <></>}
            </>
        )
    }
}

export default Shop;
